import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Typography } from 'shared/ui/Typography';

import styled from '@emotion/styled';

export const UserNameStyled = styled(Typography)({
  display: 'flex',
  flexDirection: 'column',
  fontWeight: `${theme.fontWeights.bold}`,
  fontSize: theme.fontSizes[17],
  marginBottom: theme.space[2],
});

export const UserTeamsStyled = styled(Typography)({
  fontSize: theme.fontSizes[14],
  marginRight: theme.space[2],
});

export const UserRolesStyled = styled(Typography)({
  fontSize: theme.fontSizes[14],
});

export const TeamsBlockStyled = styled(Box)({
  display: 'flex',
  gap: theme.space[2],
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
});
